import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Modules
import user from './modules/user.js'
import tag from './modules/tag.js'
import template_category from './modules/template_category.js'
import notification from './modules/notification.js'
import lost_reason from './modules/lost_reason.js'
import meeting_type from './modules/meeting_type'

export const store = new Vuex.Store({
    modules: {
      user: user,
      tag: tag,
      template_category: template_category,
      notification: notification,
      lost_reason: lost_reason,
      meeting_type: meeting_type
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js